(ns superadmin.agency-ocp.db
  (:require [clojure.spec.alpha :as spec]
            [clojure.string :as str]
            [common.form.core :as form]
            [common.url-template :as url-tpl]
            [common.validators.core :refer [valid-characters-for-name?]]
            [phrase.alpha :as p]
            [re-frame.core :as rf]))

(def entity-name "Agency")

;;
;; Validation
;;

(defn email? [email]
  (re-matches #".+\@.+\..+" email))

(spec/def ::name
  (spec/and string?
            (complement str/blank?)
            valid-characters-for-name?))

(spec/def ::value
  (spec/keys :req-un [::name]))

(p/defphraser string? [_ problem key]
  {:message "The field should be a string"
   :in (:in problem)
   :problem problem})

(p/defphraser (complement str/blank?) [_ problem]
  {:message "The field should not be empty"
   :in (:in problem)
   :problem problem})

(def validate-form
  (rf/enrich
   (form/get-validate-form-fn :form.agency ::value)))

(form/register-form {:namespace :form.agency
                     :initial-value {}
                     :validate-form validate-form
                     :submit-event :form.agency/submit-form})

;;
;; Form
;;

(rf/reg-event-fx :form.agency/init-form
  (fn [_ _]
    {:dispatch-n [[:form.agency/init]]}))

(rf/reg-event-fx :form.agency/submit-form
  (fn [_ [_ {:keys [name]}]]
    {:dispatch-n [[:loader/open]
                  [::create-agency {:name name}]]}))

(def use-bind-control (partial form/use-bind-control :form.agency))
(def use-error-message (partial form/use-error-message :form.agency))

;;
;; Backend
;;

(rf/reg-event-fx ::create-agency
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context :resource.user/token]} [_ params]]
    {:db db
     :http {:method :post
            :params params
            :uri (url-tpl/render :superadmin-api/create-agency url-context)
            :headers {"Authorization" token}
            :on-success [::create-agency-success]
            :on-failure [::create-agency-failure]}}))

(rf/reg-event-fx ::create-agency-success
  (fn [_ _]
    {:fx [[:dispatch [:ocp/close]]
          [:dispatch [:loader/close]]
          [:invalidate-queries {:queryKey ["superadmin-agencies"]}]
          [:dispatch [:response-handler/handle-response
                      {:entity-name entity-name
                       :type :success
                       :message "Successfully created agency"}]]]}))

(rf/reg-event-fx ::create-agency-failure
  (fn [_ [event response]]
    (let [message (-> response :error :message (or "Failed to create agency"))]
      {:dispatch-n [[:ocp/close]
                    [:loader/close]
                    [:response-handler/handle-response
                     {:entity-name entity-name
                      :type :error
                      :event event
                      :message message
                      :response response}]]})))
